var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column panel-fatal-elem"},[_c('div',{staticClass:"columns head"},[_c('div',{staticClass:"column"},[_c('h2',[_vm._v(_vm._s(_vm.$t('panels.fatal.headline')))]),_c('p',[_vm._v(_vm._s(_vm.$t('panels.fatal.text')))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }